var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.is_load)?_c('div',[_c('PacmanLoader')],1):_c('div',[(_vm.$store.state.is_login)?_c('div',[_c('PanelMain')],1):_c('div',[_c('PanelNotLogin')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }